import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Header from './Header'
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import useStore from './store'
import Typography from '@material-ui/core/Typography';
import _ from 'lodash'
import { CustomSelect, CustomInput, CustomCheckbox, CustomDatePicker, CustomRadioGroup } from './Component'
import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';
import Swal from 'sweetalert2';
import { Redirect } from 'react-router-dom'
import { doPost } from './AjaxRequests'
import { useHistory } from "react-router-dom";
import queryString from 'query-string'

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(5, 3),
        backgroundColor: theme.palette.paper.white,
    },
    subTitle: {
        color: theme.palette.text.white,
        fontSize: "18px"
    },
    hr: {
        margin: theme.spacing(5, 0)
    },
    btn__wrapper: {
        width: "100%",
        display: "flex",
        alignContent: "center",
        justifyContent: "center",
        padding: theme.spacing(3, 0)
    }

}));

const errorDefault = (store) => {
    let err = {}
    let page2_parts = ["travelHistory", "occupation", "contactHistory", "cluster", "healthHistory"]
    for (let x in store) {
        if (page2_parts.includes(x)) {
            err[x] = {}
            for (let y in store[x]) {
                err[x][y] = false
            }
        }
    }

    return err
}

function Page2(props) {

    const classes = useStyles(props);

    const store = useStore()

    const history = useHistory();

    const [error, setError] = useState(errorDefault(store))

    const [submiting, setSubmiting] = useState(false)



    useEffect(() => {
        const parsed = queryString.parse(props.location.search);
        let EMP2 = false

        if (parsed.EMP2) {
            if (parsed.EMP2 == "Y") {
                EMP2 = true
            }
        }

        if (!isShowPage2()) {
            Swal.fire("請先填寫基本資料", "", "info")

            if (EMP2 == true) {
                history.push("/page1?EMP2=Y")
            } else {
                history.push("/page1")
            }

        }
    }, [])


    const setTravelHistory = (field, value) => {
        let payload = {}
        payload[field] = value
        if (field == "isSelfGoAbroad" && value == "N") {
            payload.countrySelf = ""
            payload.selfDateOfEntry = ""
        }

        if (field == "isFriendGoAbroad" && value == "N") {
            payload.countryFriend = ""
        }

        if (field == "isFamilyGoAbroad" && value == "N") {
            payload.countryFamily = ""
        }

        store.setTravelHistory({ ...store.travelHistory, ...payload })
    }

    const setOccupation = (field, value) => {
        let payload = {}
        payload[field] = value
        // if(field=="occupation" && value!="others"){
        //     store.setOccupation({"others_text":"", ...payload})
        // }else{
        store.setOccupation({ ...store.occupation, ...payload })
        // }       
    }

    const setContactHistory = (field, value) => {
        let payload = {}

        if (field == "none" && value == true) {
            for (let x in store.contactHistory) {
                payload[x] = false
            }
            payload[field] = value
        } else if (field != "none" && value == true) {
            payload[field] = value
            payload["none"] = false
        } else {
            payload[field] = value
        }

        store.setContactHistory({ ...store.contactHistory, ...payload })

    }

    const setHealthHistory = (field, value) => {
        let payload = {}
        payload[field] = value

        let alertText = '具有COVID-19或類流感相關症狀，應避免至醫院陪病；如必要陪病，請出具陪病當日家用快篩陰性證明，自陪病日起(第0天)每日須進行一次家用快篩至七天期滿為止'

        if(store.gerneralInfo.reason === "EI1"){
            alertText = '具有COVID-19或類流感相關症狀，應避免至醫院探病；如必要探病，請出具探病當日家用快篩陰性證明'
        }

        if (((field === 'selfPrevention' || field === 'selfSymptom') && value === "Y") && ['EI1', "AI"].includes(store.gerneralInfo.reason)) {
            Swal.fire({
                // title: '有新冠或類流感症狀或自主防疫身份者，陪病期間每日需進行1次家用快篩(自費)，至症狀緩解或自主防疫七天期滿為止',
                html:
                alertText +
    '<br/>「病房房疫管理規定」連結頁面：<br/><a target="_blank" href="https://www.kfsyscc.org/m/探病與陪病">kfsyscc.org/m/探病與陪病</a> ' ,
                showCancelButton: true,               
                confirmButtonText: '確認',
                cancelButtonText: `取消`,
            }).then((result) => {
                console.log(result);
                /* Read more about isConfirmed, isDenied below */
                if (result.value) {                  
                    store.setHealthHistory({ ...store.healthHistory, ...payload })
                }
            })
        } else {
            store.setHealthHistory({ ...store.healthHistory, ...payload })
        }

    }

    const setCluster = (field, value) => {
        let payload = {}
        payload[field] = value

        let familyCheck = ["familyQuarantineIso", "familyQuarantineCheck", "familyHealthManage"]

        if (familyCheck.includes(field)) {

            _.map(familyCheck, (item, key) => {
                if (field == item && value == "N") {
                    let restItems = _.filter(familyCheck, (o) => { return o != item })
                    if (
                        (!store.cluster[restItems[0]] || store.cluster[restItems[0]] == "N") &&
                        (!store.cluster[restItems[1]] || store.cluster[restItems[1]] == "N")
                    ) {
                        payload["dueDate"] = ""
                    }
                }
            })
        }

        store.setCluster({ ...store.cluster, ...payload })
    }

    const handleSubmit = () => {

        setSubmiting(true)

        let err = errorDefault(store)

        if (!(process.env.REACT_APP_HOST == "emr" && store.gerneralInfo.reason == "EI3")) {

            // if(!store.travelHistory.isSelfGoAbroad){
            //     err.travelHistory.isSelfGoAbroad = true
            // }

            // if(store.travelHistory.isSelfGoAbroad == 'Y' && !store.travelHistory.countrySelf){
            //     err.travelHistory.countrySelf = true
            // }

            // if(store.travelHistory.isSelfGoAbroad == 'Y' && !store.travelHistory.selfDateOfEntry){
            //     err.travelHistory.selfDateOfEntry = true
            // }

            // if(!store.travelHistory.isSelfQuarantineIso){
            //     err.travelHistory.isSelfQuarantineIso = true
            // }

            // if(!store.travelHistory.isFriendGoAbroad){
            //     err.travelHistory.isFriendGoAbroad = true
            // }

            // if(store.travelHistory.isFriendGoAbroad == 'Y' && !store.travelHistory.countryFriend){
            //     err.travelHistory.countryFriend = true
            // }

            // if(!store.travelHistory.isFamilyGoAbroad){
            //     err.travelHistory.isFamilyGoAbroad = true
            // }

            // if(store.travelHistory.isFamilyGoAbroad == 'Y' && !store.travelHistory.countryFamily){
            //     err.travelHistory.countryFamily = true
            // }

            // let clusters = ['confirmCaseTouch','familyQuarantineIso', 'familyQuarantineCheck', 'familyHealthManage', 'familySymptom', 'friendSymptom', 'colleagueSymptom', 'rfFrequentSymptom']

            // let clusters = ['confirmCaseTouch', 'familyQuarantineIso','rfFrequentSymptom']

            // for(let x in clusters){
            //     if(!store.cluster[clusters[x]]){
            //         err.cluster[clusters[x]] = true
            //     }
            // }

            if (!store.healthHistory.selfSymptom) {
                err.healthHistory.selfSymptom = true
            }


            // if (store.gerneralInfo.reason === 'AI') {

            //     if (!store.healthHistory.selfPrevention) {
            //         err.healthHistory.selfPrevention = true
            //     }

            //     console.log(store.healthHistory.selfPrevention , store.healthHistory.selfPreventionDate);

            //     if (store.healthHistory.selfPrevention === "Y" && !store.healthHistory.selfPreventionDate) {
            //         err.healthHistory.selfPreventionDate = true
            //     }


            // }





            // if(!store.occupation.occupation){
            //     err.occupation.occupation = true
            // }



            // if(requireDueDate()){
            //     if(!store.cluster.dueDate){
            //         err.cluster.dueDate = true
            //     }            
            // }

            setError(err)

            let pass = true

            for (let x in err) {
                for (let y in err[x]) {
                    if (err[x][y]) {
                        pass = false
                    }
                }
            }

            if (pass == false) {
                setSubmiting(false)
                Swal.fire("尚有題目未填寫", "", "error")
                return
            }
        }



        // pass = false

        // for(let x in store.contactHistory){
        //     if(store.contactHistory[x]==true){
        //         pass =true
        //     }
        // }

        // if(pass==false){
        //     setSubmiting(false) 
        //     Swal.fire("接觸史若無請勾選'無'", "", "error")
        //     return
        // }

        let payload = {
            "api": "ApplyDoorAccessKey",
            "reg_date": store.gerneralInfo.reg_date,
            "apply_user_idno": store.gerneralInfo.apply_user_idno,
            "apply_user_name": store.gerneralInfo.apply_user_name,
            "apply_user_birthday": store.gerneralInfo.apply_user_birthday,
            "apply_user_mail": store.gerneralInfo.apply_user_mail,
            "apply_user_phone": store.gerneralInfo.apply_user_phone,
            "idno": store.gerneralInfo.idno,
            "reason": store.gerneralInfo.reason,
            "remark": store.gerneralInfo.remark,
            "auth_code": store.gerneralInfo.auth_code,
            // "dept":store.gerneralInfo.dept,                                     
            "cre_user_id": props.user === null ? "PATIENT" : props.user.USER_ID,
            "form_id": "V09-09-10",
            "form_ver": "3",
            "tocc": {
                travelHistory: store.travelHistory,
                occupation: store.occupation,
                contactHistory: store.contactHistory,
                cluster: store.cluster,
                healthHistory: store.healthHistory
            }
        }

        doPost('https://www.kfsyscc.org/normal_api/service', payload)
            .then((data) => {
                setSubmiting(false)


                if (data.data.pass == "Y") {
                    history.push(`/result?access_key=${data.data.access_key}`)
                } else if (data.data.pass == "N") {
                    Swal.fire(data.data.message, "", "warning")
                } else {
                    throw Error("連線錯誤")
                }

            })
            .catch((e) => {
                setSubmiting(false)
                Swal.fire(e.message, "", "error")
            })

    }


    const isShowPage2 = () => {
        if (
            store.gerneralInfo.reg_date &&
            store.gerneralInfo.apply_user_idno &&
            store.gerneralInfo.apply_user_name &&
            store.gerneralInfo.apply_user_phone &&
            store.gerneralInfo.reason &&
            store.gerneralInfo.isPass == "Y"
        ) {
            return true
        } else {
            return false
        }
    }



    const requireDueDate = () => {
        if (
            (!store.cluster.familyQuarantineIso || store.cluster.familyQuarantineIso == "N") &&
            (!store.cluster.familyQuarantineCheck || store.cluster.familyQuarantineCheck == "N") &&
            (!store.cluster.familyHealthManage || store.cluster.familyHealthManage == "N")
        ) {
            return false
        } else {
            return true
        }
    }

    console.log(store);



    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Header />
            </Grid>
            {/* travelHistory */}
            {/* <Grid item xs={12}>
                <Typography 
                    variant="h6"
                    className={classes.subTitle}
                >
                    旅遊史（過去21日內是否出過國？）
                </Typography>
            </Grid> */}
            <Grid item xs={12}>
                <Paper
                    square
                    className={classes.paper}
                    elevation={3}
                >
                    <Grid container spacing={1}>


                        <CustomRadioGroup
                            value={store.healthHistory.selfSymptom}
                            handleSelectChange={setHealthHistory}
                            label="您有自覺以下呼吸道不適或類流感症狀？例如：咳嗽、發燒、流鼻水/鼻塞、肌肉痠痛、腹瀉、嗅味覺異常、呼吸急促、四肢無力症狀"
                            field="selfSymptom"
                            error={error.healthHistory.selfSymptom}
                        />

                        {/* {store.gerneralInfo.reason === "AI" && <>

                            <CustomRadioGroup
                                value={store.healthHistory.selfPrevention}
                                handleSelectChange={setHealthHistory}
                                label="是否為自主防疫身分?"
                                field="selfPrevention"
                                error={error.healthHistory.selfPrevention}
                            />

                            <CustomDatePicker
                                width={12}
                                value={store.healthHistory.selfPreventionDate}
                                handleSelectChange={setHealthHistory}
                                label="自主防疫開始日期"
                                field="selfPreventionDate"
                                // disablePast
                                // minDate={props.user == null ? new Date() : new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 30))}
                                // maxDate={new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 1))}
                                error={error.healthHistory.selfPreventionDate}
                            />

                        </>} */}


                    </Grid>
                </Paper>
            </Grid>


            <Grid item xs={12}>
                {submiting ? null :
                    <div className={classes.btn__wrapper}>
                        <Button variant="contained" color="primary" onClick={handleSubmit}>
                            送出
                        </Button>
                    </div>
                }
            </Grid>
        </Grid>
    );
}




export default Page2